import { unityPropsContext } from 'components/UnityPropsContext'
import React, { FC, ReactElement, useContext } from 'react'
import styled from 'styled-components'
import type { Question } from 'Types/Questions'
import { device } from '../../breakpoints'

interface Props {
  question: Question
}
const QuestionImage: FC<Props> = ({
  question
}): ReactElement => {
  return (
    <Container imageX={question.meta.imagePosition} imageUrl={question.meta.image} />
  )
}
const Container = styled.div<{imageUrl: string | undefined, imageX: string | undefined }>`
  display: block;
  position: relative;
  // max-width: 360px;
  margin: 0 auto;
  height: 90vh;
  background-align: center;
  background-size: cover;
  background-repeat: no-repeat;
  margin-bottom: 50px;

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    background-attachment: none;
    background-position: ${({imageX}) => `${imageX} center`};
    background-image: ${({imageUrl}) => `url(${require(`../../../Assets/images/${imageUrl}.jpg`)})`};
  }

  @media ${device.tablet}, @media ${device.laptop} {
    background-attachment: fixed;
    background-position: center;
    background-image: ${({imageUrl}) => `url(${require(`../../../Assets/images/${imageUrl}.jpg`)})`};
  }
`

const Image = styled.img`
  width: 100%;
`

export default QuestionImage
